import Vue from 'vue'
import VueRouter from 'vue-router'
import { BasicLayout } from '@/layouts'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页', companyName: '上海惟嘉经贸有限公司 爱格EGGER | 可丽芙CLEAF华东地区代理商' },
  },
  {
    path: '/main',
    name: 'Main',
    component: BasicLayout,
    redirect: '/main/home',
    children: [
      {
        path: '/main/home',
        name: 'Cleaf',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/Home'),
        meta: { title: '首页', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/About'),
        meta: { title: '关于我们', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/news',
        name: 'News',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/News'),
        meta: { title: '新闻动态', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/product',
        name: 'Product',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/Product'),
        meta: { title: '产品展示', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/series',
        name: 'Series',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/Series'),
        meta: { title: '花色系列', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/customer',
        name: 'Customer',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/Customer'),
        meta: { title: '授权客户', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/Contact'),
        meta: { title: '联系我们', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/newsdetails',
        name: 'NewsDetails',
        props: true,
        hidden: true,
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/NewsDetails'),
        meta: { title: '新闻详情', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/productdetails',
        name: 'ProductDetails',
        props: true,
        hidden: true,
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/ProductDetails'),
        meta: { title: '产品详情', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/seriesdetails',
        name: 'SeriesDetails',
        props: true,
        hidden: true,
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/SeriesDetails'),
        meta: { title: '花色详情', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
      {
        path: '/main/customerdetails',
        name: 'CustomerDetails',
        props: true,
        hidden: true,
        component: () => import(/* webpackChunkName: "home" */ '@/views/cleaf/CustomerDetails'),
        meta: { title: '客户详情', companyName: '可丽芙CLEAF华东地区代理商——惟嘉经贸' },
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

const router = new VueRouter({
  routes,
})

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.companyName) {
    document.title = to.meta.companyName
  }
  next()
})

export default router
